<template>
    <div>
        <v-row class="px-2 pt-2">
            <!-- Merchant -->
            <v-col md="4" class="py-0">
                <v-autocomplete
                    v-model="merchant"
                    label="Select a merchant"
                    :items="merchants"
                    item-value="merchantId"
                    item-text="merchantName"
                    dense
                    return-object
                    clearable
                    @change="getReport();
                    loading = true;"
                    @click:clear="clearMerchant()"
                ></v-autocomplete>
            </v-col>
        </v-row>

        <v-row class="px-2 pt-2" align="center" justify="center">
            <v-col md="4" class="py-0">
                <v-btn fab text small color="blue darken-2" @click="prev(); handleCalTitle('l');">
                    <v-icon medium>mdi-chevron-left</v-icon>
                </v-btn>
            </v-col>

            <v-col md="4" class="py-0" align="center" justify="center">{{ calTitle }}</v-col>

            <v-col md="4" class="py-0" align="end">
                <v-btn fab text small color="blue darken-2" @click="next(); handleCalTitle('r');">
                    <v-icon medium>mdi-chevron-right</v-icon>
                </v-btn>
            </v-col>
        </v-row>

        <v-row class="px-2 pt-2">
            <v-col md="12" class="py-0">
                <v-sheet height="1200">
                    <v-calendar
                        v-model="focus"
                        ref="calendar"
                        :weekdays="weekday"
                        :type="type"
                        :events="events"
                        event-overlap-mode="stack"
                        :event-overlap-threshold="30"
                        :event-color="getEventColor"
                        :event-more="false"
                    >
                    <template v-slot:event="{ event }">
                        <span class="cal-title">{{ event.title }}:</span>
                        <span class="cal-body">£{{ event.body }}</span>

                        <!-- Commented out incase we switch back to tooltip formatting -->
                        <!-- <div v-if="event.title !== 'Collections'">
                            <span class="cal-title">{{ event.title }}:</span>
                            <span class="cal-body">£{{ event.body }}</span>
                        </div>
                        <div>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <div v-bind="attrs" v-on="on">
                                        <span class="cal-title">{{ event.title }}:</span>
                                        <span class="cal-body">£{{ event.body }}</span>
                                    </div>
                                </template>
                                <div>
                                    <div v-for="item in amountTakenAgg[event.start]" :key="item.source">
                                        <span class="cal-body">{{item.source}}: £{{ item.amountTaken }}</span>
                                    </div>
                                </div>
                            </v-tooltip>
                        </div> -->
                    </template>
                    </v-calendar>
                </v-sheet>
            </v-col>
        </v-row>

        <v-overlay :value="loading">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';

export default {
    data() {
        return {
            focus: '',
            merchants: null,
            merchant: {},
            loading: true,
            today: '',
            type: 'month',
            weekday: [1, 2, 3, 4, 5, 6, 0],
            events: [],
            calTitle: moment().format('MMMM YYYY')
        }
    },
    beforeMount() {
        this.getMerchants();
        this.getReport();
    },
    methods: {
        getMerchants() {
            if(this.$store.state.user.user_role.id <= 3) {
                axios({
                method: 'get',
                url: `get-crm-merchants-live`,
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    console.log(response.data);
                    this.merchants = response.data;
                })
                .catch(e => {
                    this.errors.push(e)
                })
            }
            else if(this.$store.state.user.user_role.id > 3) {
                axios({
                method: 'post',
                url: `get-crm-merchants-live-client`,
                data: { userId: this.$store.state.user.id },
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    this.merchants = response.data;
                })
                .catch(e => {
                    this.errors.push(e)
                })
            }
        },
        getReport() {
            this.events = [];
            this.amountTakenAgg = {};

            axios({
                method: 'post',
                url: `scheduler-cal-stats`,
                data: { merchant: typeof this.merchant !== 'undefined' ? this.merchant.merchantId : null },
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
            })
            .then(response => {
                console.log("data: ", response.data);
                response.data.map(e => {
                    this.events.push({
                        title: 'Projected',
                        body: e.projAmount,
                        start: e.date,
                        color: '#42A5F5',
                    });
                    if(e.amountTaken) {
                        this.events.push({
                            title: 'Collections',
                            body: e.amountTaken,
                            start: e.date,
                            color: '#1976D2'
                        });

                        var aggObj = JSON.parse(e.amountTakenArr)
                        // this.amountTakenAgg[e.date] = aggObj.data;

                        var keys = [];
                        var aggSourceEvents = [];
                        aggObj.map(f => {
                            var col = '#1976D2'
                            switch (f.source) {
                                case 'Scheduler':
                                    col = '#328ce7';
                                    break;
                                case 'Paybylink':
                                    col = '#5fa6ec';
                                    break;
                                case 'Rebiller':
                                    col = '#8dbff2';
                                    break;
                                case 'MOTO':
                                    col = '#1566b7';
                                    break;
                            }

                            keys.push(f.source)
                            aggSourceEvents[f.source] = {
                                title: f.source,
                                body: f.amountTaken,
                                start: e.date,
                                color: col
                            };
                        })

                        keys.sort();
                        keys.forEach(key => {
                            var eventObj = aggSourceEvents[key];
                            this.events.push(eventObj);
                        });
                    }
                }); 
                this.loading = false;
            })
            .catch(e => {
                console.log(e)
                this.errors.push(e)
            })
        },
        getEventColor(event) {
            return event.color;
        },
        clearMerchant() {
            console.log(this.merchant);
            this.events = [];
        },
        prev() {
            this.$refs.calendar.prev();
        },
        next() {
            this.$refs.calendar.next();
        },
        handleCalTitle(e) {
            const date = moment(this.calTitle, 'MMMM YYYY').format('YYYY-MM-DD');

            if(e == 'l') {
                this.calTitle = moment(date).subtract(1, 'months').format('MMMM YYYY');
            }
            else {
                this.calTitle = moment(date).add(1, 'months').format('MMMM YYYY');
            }
        },
    }
}
</script>

<style>
    .v-event {
        width: 96% !important;
        margin-left: 2% !important;
        margin-bottom: 2px !important;
    }
    
    .cal-title {
        display: inline-flex;
        padding-left: 5px;
        width: 50%;
        font-weight: 600;
    }

    .v-calendar-weekly__day.v-outside {
        background-color: #F8F8F8;
        border-right: #e0e0e0 1px solid !important;
    }

    .v-calendar.v-calendar-events .v-calendar-weekly__day,
    .v-calendar.v-calendar-events .v-calendar-weekly__head-weekday {
        margin-right: 0px !important;
    }

    .v-calendar-weekly__head-weekday {
        border-bottom: #e0e0e0 1px solid !important;
        padding: 5px !important;
    }

    .v-present .v-btn {
        background-color: #42A5F5 !important;
    }

    .v-present .v-btn .v-btn__content {
        color: #fff !important;
    }
    
    .v-calendar .v-btn--fab.v-size--small {
        width: 30px !important;
        height: 30px !important;
        margin-bottom: 5px !important;
    }
</style>